import { Injectable } from "@angular/core";
import { SharedService } from "./shared.service";
import { HttpClient } from "@angular/common/http";
@Injectable({
  providedIn: "root",
})
export class EaseBuzzAPIService {
  url;
  constructor(sharedService: SharedService, private httpClient: HttpClient) {
    this.url = sharedService.baseURL;
  }
  CheckUPI(data: any): any {
    return this.httpClient.post<any>(
      `${this.url}/api/EaseBuzzAPIs/CheckUPI`,
      data
    );
  }
  WalletTransfer(data: any): any {
    return this.httpClient.post<any>(
      `${this.url}/api/EaseBuzzAPIs/WalletTransfer`,
      data
    );
  }
  CheckAccount(data: any): any {
    return this.httpClient.post<any>(
      `${this.url}/api/EaseBuzzAPIs/CheckAccount`,
      data
    );
  }
  QuickTransferAsync(data: any): any {
    return this.httpClient.post<any>(
      `${this.url}/api/EaseBuzzAPIs/QuickTransferAsync`,
      data
    );
  }
}
